import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateProductMutation } from "../graphql/mutations";
import type {
  UpdateProductMutationType,
  UpdateProductMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateProductMutation = (
  options?: MutationHookOptions<
    UpdateProductMutationType,
    UpdateProductMutationVariablesType
  >
) => {
  return useMutation<
    UpdateProductMutationType,
    UpdateProductMutationVariablesType
  >(UpdateProductMutation, options);
};
